import { render } from "./barEcharts.vue?vue&type=template&id=66be5580&scoped=true"
import script from "./barEcharts.vue?vue&type=script&lang=js"
export * from "./barEcharts.vue?vue&type=script&lang=js"

import "./barEcharts.vue?vue&type=style&index=0&id=66be5580&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66be5580"]])

export default __exports__